@if (isVisible) {
  <div class="ag-filter">
    <div _ngcontent-pmu-c133="">
      <div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
        <div ref="eCondition1Body" class="ag-filter-body">
          <div ref="eCondition1PanelFrom" class="ag-filter-from ag-filter-date-from">
            <div class="ag-filter-filter">
              <div role="presentation" ref="eDateInput" class="ag-date-filter ag-labeled ag-label-align-left ag-text-field ag-input-field">
                <div ref="eWrapper" role="presentation" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper">
                  <input class="ag-filter-filter ng-pristine ng-valid ng-touched" type="text" pInputText #filterValueInp
                    placeholder="Min..." ref="eValueTo" [ngModel]="filter" defaultValue="{{displaySymbol}}" [(duxIrbCurrencyFormatter)]="filter" (keyup.enter)="onApplyAction();">
                </div>
              </div>
            </div>
          </div>
          <div class="ag-filter-filter">
            <div role="presentation" ref="eDateInput" class="ag-date-filter ag-labeled ag-label-align-left ag-text-field ag-input-field">
              <div ref="eWrapper" role="presentation" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper">
                <input style="margin-top: 10px;" class="ag-filter-filter ng-pristine ng-valid ng-touched" ref="eValueTo1" type="text" pInputText
                #filterValueToInp placeholder="Max..." [ngModel]="filterTo" [(duxIrbCurrencyFormatter)]="filterTo" defaultValue="{{displaySymbol}}" (keyup.enter)="onApplyAction();"> </div>
              </div>
            </div>
            @if (isMinMaxValidationError) {
              <div style="color: red; padding: 3px; ">Please check min and max values</div>
            }
          </div>
        </div>
      </div>
      <div class="ag-filter-apply-panel">
        <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="resetFilterButton" (click)="onClearAction()">Clear</button>
        <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="applyFilterButton" (click)="onApplyAction();"  >Apply</button>
      </div>
    </div>
  }
